import { Button, Radio } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { App } from 'antd';
import ConditionBuilder from './ConditionBuilder';
import { wouldBeDuplicate } from '../constants';

function Step2Conditions({ segmentData, onChange }) {
  const { condition_logic, conditions } = segmentData;
  const { message } = App.useApp();

  const addCondition = () => {
    const newCond = { field: 'total_spent', operator: 'gt', value: 0 };
    if (wouldBeDuplicate(conditions || [], newCond)) {
      message.warning('This condition already exists. Each condition must be unique.');
      return;
    }
    onChange({
      ...segmentData,
      conditions: [...(conditions || []), newCond],
    });
  };

  const updateCondition = (index, newCond) => {
    if (wouldBeDuplicate(conditions || [], newCond, index)) {
      message.warning('This condition already exists. Each condition must be unique.');
      return;
    }
    const next = [...(conditions || [])];
    next[index] = newCond;
    onChange({ ...segmentData, conditions: next });
  };

  const removeCondition = (index) => {
    const next = (conditions || []).filter((_, i) => i !== index);
    onChange({ ...segmentData, conditions: next });
  };

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, fontWeight: 600 }}>Condition logic</div>
        <Radio.Group
          value={condition_logic || 'all'}
          onChange={(e) => onChange({ ...segmentData, condition_logic: e.target.value })}
        >
          <Radio value="all">ALL conditions</Radio>
          <Radio value="any">ANY condition</Radio>
        </Radio.Group>
      </div>
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, fontWeight: 600 }}>Segment Conditions</div>
        {(conditions || []).map((cond, i) => (
          <ConditionBuilder
            key={i}
            condition={cond}
            index={i}
            onChange={(c) => updateCondition(i, c)}
            onRemove={() => removeCondition(i)}
          />
        ))}
        <Button type="link" icon={<PlusOutlined />} onClick={addCondition}>
          Add Condition
        </Button>
      </div>
    </div>
  );
}

export default Step2Conditions;
